var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRoomAirDestratification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 7.50833L5.84167 7.49907M9.16667 7.50833L9.175 7.49907M5.83333 10.8417L5.84167 10.8324M9.16667 10.8417L9.175 10.8324M5.83333 14.175L5.84167 14.1657M9.16667 14.175L9.175 14.1657M12.5 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17V4.66667C2.5 4.39052 2.72386 4.16667 3 4.16667H7.5V3C7.5 2.72386 7.72386 2.5 8 2.5H12C12.2762 2.5 12.5 2.72386 12.5 3V7.5M12.5 17.5H17C17.2762 17.5 17.5 17.2762 17.5 17V8C17.5 7.72386 17.2762 7.5 17 7.5H12.5M12.5 17.5V14.1667M12.5 7.5V10.8333M12.5 14.1667V10.8333M12.5 14.1667H14.1667M12.5 10.8333H14.1667",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoomAirDestratification);
export default __webpack_public_path__ + "static/media/icon-room-air-destratification.cba6d3d7ec1e9fec0a641de5b43d44fe.svg";
export { ForwardRef as ReactComponent };